// extracted by mini-css-extract-plugin
export default {"root":"MobileTrashbinPage__root--3FiAe","content":"MobileTrashbinPage__content--2IZ-B","menu":"MobileTrashbinPage__menu--3Bto6"};